import clsx from 'clsx';

import { FieldWrapper } from './FieldWrapper';

export const InputField = (props) => {
  const {
    type = 'text',
    label,
    className,
    onChange,
    maxLength,
    caption,
    disabled,
    value,
    registration,
    error,
    required,
  } = props;

  return (
    <FieldWrapper label={label} error={error}>
      <div className="my-1 text-sm flex justify-start">{caption}</div>
      <input
        type={type}
        maxLength={maxLength}
        value={value}
        disabled={disabled}
        required={required}
        className={clsx(
          'appearance-none block w-full px-3 py-3 border bg-[#4D5369] border-[#383D4E] rounded-md shadow-sm placeholder-[#4D5369] focus:outline-none focus:ring-[#383D4E] focus:border-[#383D4E] text-white sm:text-sm',
          className
        )}
        onChange={onChange}
        {...registration}
      />
    </FieldWrapper>
  );
};
